/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,jsx-a11y/iframe-has-title */
import { FC, useState } from 'react'
import { Image, Modal, Popover } from 'antd'
import classNames from 'classnames'
import { Message } from 'types'
import ReactPlayer from 'react-player'
import {
	RiDownload2Fill,
	RiHeadphoneFill,
	RiListCheck,
	RiPlayCircleFill,
} from 'react-icons/ri'
import AudioPlayer from 'component/UI/AudioPlayer'
import getMessageHTML from 'utils/getMessageHTML'
import downloadFile from 'utils/downloadFile'
import DOMPurify from 'dompurify'
import styles from './styles.module.scss'

export interface MessagePreviewProps {
	message: Message
	showArrow?: boolean
}

const MessagePreview: FC<MessagePreviewProps> = ({ message, showArrow }) => {
	const [videoModal, setVideoModal] = useState(false)

	return (
		<>
			<div
				className={classNames(styles.message, {
					[styles.arrow]: showArrow,
				})}
			>
				{message.type === 'MEDIA_IMAGE' && (
					<div className={styles.image}>
						<Image src={message.image?.link || ''} alt='' />
					</div>
				)}
				{message.type === 'MEDIA_VIDEO' && (
					<div className={styles.video}>
						<div className={styles.videoWrapper}>
							<ReactPlayer url={message.video?.link} />
							<div className='ant-image-mask' onClick={() => setVideoModal(true)}>
								<div className='ant-image-mask-info' />
							</div>
							<RiPlayCircleFill
								color='#ffffff'
								size={50}
								className={styles.playIcon}
							/>
						</div>
					</div>
				)}
				{message.type === 'MEDIA_AUDIO' && (
					<div className={styles.audio}>
						<div className={styles.container}>
							<AudioPlayer url={message.audio?.link || ''} />
							<div className={styles.headPhone}>
								<RiHeadphoneFill size={24} color='#FFFFFF' />
							</div>
						</div>
					</div>
				)}
				{message.type === 'MEDIA_DOCUMENT' && (
					<div className={styles.document}>
						{message.document?.fileName.includes('.pdf') ? (
							<div
								className={styles.pdfContainer}
								onClick={() =>
									downloadFile(message.document!.url, message.document!.fileName)
								}
							>
								<iframe
									src={message.document.url}
									className={styles.pdf}
									frameBorder='0'
									scrolling='no'
									seamless
								/>
							</div>
						) : (
							<div className={styles.container}>
								<a
									href={message.document?.url}
									target='_blank'
									download
									rel='noreferrer'
								>
									{message.document?.fileName}
								</a>
								<div
									className={styles.downloadButton}
									onClick={() =>
										downloadFile(message.document!.url, message.document!.fileName)
									}
								>
									<RiDownload2Fill size={24} color='#FFFFFF' />
								</div>
							</div>
						)}
					</div>
				)}
				<div
					hidden={getMessageHTML(message) === '<p></p>'}
					className={styles.text}
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{
						__html: DOMPurify.sanitize(getMessageHTML(message)),
					}}
				/>
				<div className={styles.time}>08:56 p.m.</div>
			</div>
			{message.options?.map(button => (
				<div key={button.title} className={styles.button}>
					{button.title}
				</div>
			))}
			{message.listOptions?.button && (
				<div className={styles.button}>
					<Popover
						overlayClassName={styles.overlay}
						content={
							<div className={styles.listOptions}>
								{message.listOptions.sections.map(section =>
									section.rows?.map(row => (
										<div className={styles.listOption} key={row.id}>
											<span>{row.title}</span>
											<div className={styles.radio} />
										</div>
									))
								)}
							</div>
						}
					>
						<div className={styles.listMenuButton}>
							<RiListCheck /> <span>{message.listOptions?.button}</span>
						</div>
					</Popover>
				</div>
			)}
			<Modal
				destroyOnClose
				visible={videoModal}
				footer={null}
				onCancel={() => setVideoModal(false)}
				maskClosable
				width='fit-content'
				title='Video Preview'
			>
				<ReactPlayer url={message.video?.link} controls />
			</Modal>
		</>
	)
}

export default MessagePreview
